import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
name: 'validacionActivo'
})
export class ActivoPipe implements PipeTransform {
activo: string;
// tslint:disable-next-line:indent
    transform(value: boolean) {
// tslint:disable-next-line:indent
        if (value) {
// tslint:disable-next-line:indent
            return this.activo = 'SI';
// tslint:disable-next-line:indent
        } else {
// tslint:disable-next-line:indent
            return this.activo = 'NO';
// tslint:disable-next-line:indent
        }
// tslint:disable-next-line:indent
     }
}

